// What the colours and markers mean, on every view.
const PERSONAS = ['champion', 'decision-maker', 'influencer', 'challenger', 'gatekeeper', 'user'] as const
const MARKERS: { short: string; tone: string; label: string }[] = [
  { short: '!', tone: 'threat', label: 'Competitor in the room — a threat, not an opportunity' },
  { short: 'P', tone: 'action', label: 'Prep this' },
  { short: '1', tone: 'signal', label: 'First meeting with the account' },
  { short: 'D', tone: 'signal', label: 'Decision maker in the room' },
  { short: 'T', tone: 'signal', label: 'Transcript linked' },
  { short: 'R', tone: 'watch', label: 'Quiet contact resurfacing' },
  { short: 'M', tone: 'watch', label: 'Contact may have moved' },
  { short: 'X', tone: 'action', label: 'Tactic due' },
]

export function Legend() {
  return (
    <div className="cal-legend" aria-label="Legend">
      <div className="cal-legend-group">
        <span className="cal-legend-title">Room</span>
        <span className="cal-legend-item"><i className="cal-legend-swatch threat" />A rival is in it</span>
        <span className="cal-legend-item"><i className="cal-legend-swatch kind-client" />Client, in the account's colour</span>
        <span className="cal-legend-item"><i className="cal-legend-swatch kind-external" />Outside people not yet in your contacts</span>
        <span className="cal-legend-item"><i className="cal-legend-swatch kind-internal" />Colleagues only</span>
      </div>
      <div className="cal-legend-group">
        <span className="cal-legend-title">Persona</span>
        {PERSONAS.map((p) => <span key={p} className={`cal-legend-item persona-${p}`}><i className="persona-dot" />{p === 'decision-maker' ? 'Decision maker' : p[0].toUpperCase() + p.slice(1)}</span>)}
      </div>
      <div className="cal-legend-group">
        <span className="cal-legend-title">Callouts</span>
        {MARKERS.map((m) => <span key={m.short} className="cal-legend-item"><i className={`cal-marker tone-${m.tone}`}>{m.short}</i>{m.label}</span>)}
        <span className="cal-legend-item"><i className="cal-legend-swatch heat" />Busier days run warmer on the month</span>
      </div>
    </div>
  )
}
